export class CalendarPlanListDbResponse {
  calendarPlanListId: number;
  planName: string;
  totalScore: number;
  averageScore: number;
}

export class PatientPlanDbResponse {
  patientPlanId: number;
  planName: string;
  localDateTime: Date;
  isFavourite: boolean;
  isComplete: boolean;
  sortOrder: number;
  isCurrent: boolean;
}

export class PatientPlans {
  allPlans: PatientPlanDbResponse[];
  parentPlans: PatientPlanDbResponse[];
  favParentPlans: PatientPlanDbResponse[];
  currentPlan: PatientPlanDbResponse;
}

export class CalendarPlanList {
  currentPlan: CalendarPlanListDbResponse[];
}

export class CalendarPlanListModel {
  Date: string;
  Plans: {
    ID: number;
    Name: string;
    TotalScore: number;
    AverageScore: number;
  }[];
}
